import { render, staticRenderFns } from "./_general-report-matrix.component.vue?vue&type=template&id=78ac5469&scoped=true"
import script from "./_general-report-matrix.component.vue?vue&type=script&lang=js"
export * from "./_general-report-matrix.component.vue?vue&type=script&lang=js"
import style0 from "./_general-report-matrix.component.vue?vue&type=style&index=0&id=78ac5469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac5469",
  null
  
)

export default component.exports